import {PageManager} from '@mvps-genesis/bootstrap';
import './LOGN.scss';

export default class LOGN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {
		this.createAccountForm = document.getElementById('new-customer-form');
		this.emailSignupCheckbox = document.getElementById('msgpref');

		if (this.emailSignupCheckbox && this.createAccountForm) {
			this.createAccountForm.addEventListener('submit', async (e) => {
				if (this.emailSignupCheckbox.checked) {
					e.preventDefault();
					await this.emailSignupAdd();
				}
			});
		}
	}

	async emailSignupAdd () {
		const firstNameElem = document.getElementById('l-register_fname');
		const lastNameElem = document.getElementById('l-register_lname');
		const emailElem = document.getElementById('l-register_email');

		const firstName = firstNameElem ? firstNameElem.value : '';
		const lastName = lastNameElem ? lastNameElem.value : '';
		const email = emailElem ? emailElem.value : '';

		await fetch(`${this.pageContext.Japi_Url}_cachebust=${Date.now()}`, {
			body: JSON.stringify({
				email: email,
				firstName: firstName,
				function: 'EMAIL_SIGNUP',
				lastName: lastName,
				source: 'account_creation'
			}),
			credentials: 'same-origin',
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				Expires: 0,
				Pragma: 'no-cache'
			},
			method: 'POST'
		});

		this.createAccountForm.submit();
	}

};
